module.exports = __webpack_public_path__ + "img/sync-digikala.a54f3e84.png";